var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"-p-relative"},[_c('div',{directives:[{name:"hammer",rawName:"v-hammer:pan.horizontal",value:(
      !_vm.noScroll && !_vm.nativeScroll && _vm.totalSlides > _vm.visibleSlides && !_vm.viewAsGrid
        ? _vm.swipe
        : function () {}
    ),expression:"\n      !noScroll && !nativeScroll && totalSlides > visibleSlides && !viewAsGrid\n        ? swipe\n        : () => {}\n    ",arg:"pan",modifiers:{"horizontal":true}},{name:"hammer",rawName:"v-hammer:panend",value:(
      !_vm.noScroll && !_vm.nativeScroll && _vm.totalSlides > _vm.visibleSlides && !_vm.viewAsGrid
        ? _vm.onPanEnd
        : function () {}
    ),expression:"\n      !noScroll && !nativeScroll && totalSlides > visibleSlides && !viewAsGrid\n        ? onPanEnd\n        : () => {}\n    ",arg:"panend"}],ref:"slider",staticClass:"generic-slider grid p-t-0 p-b-0",class:{
      '-disable-slider': _vm.viewAsGrid,
      '-touch-scroll': _vm.nativeScroll && !_vm.viewAsGrid,
      '-sliding': _vm.isSliding,
      '-fullwidth': _vm.fullWidth,
    }},[_c('div',{ref:"sliderWrapper",class:[
        !_vm.viewAsGrid
          ? 'generic-slider-wrapper no-scrollbar'
          : 'grid-12 -view-as-grid',
        {
          '-animate': this.cssAnimate && this.ready,
          '-ready': this.ready,
          '-looped': _vm.looped,
        } ],style:(_vm.wrapperStyle)},[_vm._t("default")],2),(_vm.controls && _vm.totalSlides > _vm.visibleSlides && !_vm.viewAsGrid)?_c('SliderControls',{attrs:{"slidesLength":_vm.totalSlides,"hideLeft":_vm.isOnLeftEdge,"hideRight":_vm.isOnRightEdge,"colorOverride":_vm.colorOverride,"circled":_vm.circledControls,"largeHitAreas":_vm.fullWidth,"navPlacement":_vm.fullWidth ? (_vm.$mqAliases.desktop ? '36px' : '18px') : '0'},on:{"prev":_vm.prev,"next":_vm.next,"goto":function (index) { return _vm.gotoindex(index); }}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }